<template>
  <div id="report" class="report">
    <div class="card">    
      <button class="btn backBtn" @click="$router.push({ path: '/' })"><i class="icon-left-open"></i></button>
      <div class="cardHeader">
          <span class="mainHeader">CONTACT LIST <small>ETHEKWINI MUNICIPALITY</small></span>
          <!-- <span class="secondHeader">Send us feedback on any enviromental issues in your area.</span> -->
      </div>
      <div class="cardBody">
        <table class="emergencyNumbers">
          <tbody>
            <tr>
              <td><h3>AIDS HELP LINE</h3></td>
              <td><a href="tel:0800012322">0800 012 322</a></td>
            </tr>
            <tr>
              <td><h3>AMBULANCE (PUBLIC)</h3></td>
              <td><a href="tel:10177">10177</a></td>
            </tr>
            <tr>
              <td><h3>AMBULANCE (PRIVATE)</h3></td>
              <td><a href="tel:082911">082 911</a></td>
            </tr>
            <tr>
              <td>
                <h3>AIR POLLUTION</h3>
                <p>Operating Hours <br>8:00-16:00 Mon - Fri<br> After Hours contact Emergency Services </p>
              </td>
              <td><a href="tel:0313113122">031 311 3122</a> <br><br><a href="tel:0313610000">031 361 0000</a></td>
            </tr>
            <tr>
              <td>
                <h3>BEACHES AND RECREATION FACILITIES</h3>
                <p>Operating Hours 7:30 - 18:00</p>
              </td>
              <td><a href="tel:031 322 4350">031 322 4350</a></td>
            </tr>
            <tr>
              <td>
                <h3>DEVELOPMENT PLANNING</h3>
                <p>Operating Hours <br>7:00-16: 30 Mon - Fri <br>Sub Division <br>Rezoning <br>Special Consent</p>
              </td>
              <td><a href="tel:0313117883">031 311 7883</a></td>
            </tr>
            <tr>
              <td>
                <h3>DEVELOPMENT MANAGEMENT</h3>
                <p>Building Inspectorate <br> Plans Submissions<br> Enforcement</p>
              </td>
              <td><a href="tel:0313117881">031 311 7881</a></td>
            </tr>
            <tr>
              <td>
                <h3>ADVERTISING AND SIGNAGE</h3>
              </td>
              <td><a href="tel:0313117055">031 311 7055</a></td>
            </tr>
            <tr>
              <td>
                <h3>ENVIRONMENT</h3>
              </td>
              <td><a href="tel:0313117875">031 311 7875</a></td>
            </tr>
            <tr>
              <td>
                <h3>ENGINEERING SERVICES CENTRE</h3>
                <p>Operating Hours 24 Hours,
                  <br> 7 Days a week:
                  <br>Road repairs
                  <br>Stormwater Blockages/Repairs 
                  <br>Replacement of manhole covers 
                  <br>Repairs of guardrails and 
                  <br>roadside fencing 
                  <br>Sidewalk and Kerb repairs 
                  <br>Sewer Repairs/ Blockages 
                  <br>Road Marking and Street Signs 
                  <br>Water Reconnections / Accounts 
                  <br>Faulty Traffic Signal 
                  <br>Flooding Coastal Infrastructure 
                  <br>Water faults 
                  <br>Water Pollution 
                  <br>Water Account Queries
                  <br>Whatsapp: 
                  <br>SMS No.:
                  <br>Fax No.:
                  <br>Email : <a href="mailto:eservices@dmws.durban.gov.za">eservices@dmws.durban.gov.za</a>
                </p>
              </td>
              <td><a href="tel:0801313013">080 131 3013</a><br><br><br><br><br><br><br><br><br><br>
              <a href="https://api.whatsapp.com/send?phone=270731483477" target="_blank"><i class="icon-whatsapp"></i> 073 148 3477</a><br>
              <a href="sms:0837073013" >083 707 3013</a><br><a href="tel:0313118220" >031 311 8220</a><br></td>
            </tr>
             <tr>
              <td>
                <h3>ETHEKWINI REVENUE CALL CENTRE</h3>
              </td>
              <td><a href="tel:0313245000" >031 324 5000</a></td>
            </tr>
            <tr>
              <td>
                <h3>WATER FAULTS CALL CENTRE</h3>
                <p>Operating Hours <br>7:00-16: 30 Mon - Fri <br>Sub Division <br>Rezoning <br>Special Consent</p>
              </td>
              <td><a href="tel:0801313013" >080 131 3013</a></td>
            </tr>

          </tbody>
        </table>
        <table class="emergencyNumbers">
          <tbody>   
            <tr>
              <td>
                <h3>ELECTRICITY FAULTS CALL CENTRE</h3>
                <p>Operating Hours
                  <br>7:30 -16:30 Mon - Fri
                  <br>and 7:30 - 11:30 on Sat 
                  <br>Rates 
                  <br>Electricity 
                  <br>Water Accounts
                </p>
              </td>
              <td><a href="tel:0801313111" >080 131 3111</a></td>
            </tr>
            <tr>
              <td>
                <h3>EMERGENCY SERVICES:</h3>
                <p>Operating 24 Hours, 7 Days a week:</p>
                <ul>
                  <li>Fire</li>
                  <li>Disaster Management</li>
                  <li>Metro Police</li>
                </ul>
              </td>
              <td><a href="tel:0313610000" >031 361 0000</a></td>
            </tr>
            <tr>
              <td>
                <h3>ELECTRICITY CALL CENTRE</h3>
                <p>Operating Hours 24 Hours,
                  <br>7 Days a week: 
                  <br>Electricity Faults and Breakdowns  
                  <br>Street Lights 
                  <br>Illegal Connections 
                  <br>Cable Theft </p>
              </td>
              <td><a href="tel:0801313111" >080 13 13 111</a><br><br><br><br><a href="tel:0313119611" >031 311 9611</a></td>
            </tr>
            <tr>
              <td>
                <h3>HEALTH</h3>
                <p>Operating Hours 7:00-16:30 Mon to Fri
                  <br>After Hours contact Emergency Services
                  <br>Air Pollution 
                  <br>Environmental Noise 
                  <br>Illegal Dumping 
                  <br>Food Safety 
                  <br>Communicable Diseases 
                  <br>Hazardous Chemical Substances
                  <br>Vector Control (Mosquitoes,Flies,rats,etc)</p>
              </td>
              <td><a href="tel:0313113555" >031 311 3555</a></td>
            </tr>
            <tr>
              <td>
                <h3>ILLEGAL DUMPING</h3>
                <p>Operating Hours 7:30-16:00 Mon to Fri</p>
              </td>
              <td><a href="tel:0313031665" >031 303 1665</a><br><a href="tel:0313118804" >031 311 8804</a></td>
            </tr>
            <tr>
              <td>
                <h3>REFUSE REMOVAL</h3>
                <p>Operating Hours 7:30-16:00 Mon to Fri
                  <br>Removal of dead animals</p>
              </td>
              <td><a href="tel:0313118804" >031 311 8804</a></td>
            </tr>
            <tr>
              <td>
                <h3>PARKS, LEISURE AND CEMETERIES</h3>
                <p>Operating Hours 7:30-16:00 Mon to Fri
                  <br>Verge and grass maintenance 
                  <br>Fallen and Trimming of trees after Hours</p>
              </td>
              <td><a href="tel:0313224000" >031 322 4000</a><br><a href="tel:0313610000" >031 361 0000</a></td>
            </tr>

            <tr>
              <td>
                <h3>OMBUDSPERSON AND HEAD INVESTIGATIONS</h3>
                <p>Operating Hours 8:00-16:00 Mon to Fri
                  <br>Reporting Incidents within Municipality of:
                  <br>Fraud and Corruption 
                  <br>Maladministration 
                  <br><a href="maito:ombudsperson@durban.gov.za" >ombudsperson@durban.gov.za</a></p>
              </td>
              <td><a href="tel:0800202020" >080 020 2020</a></td>
            </tr>

            <tr>
              <td>
                <h3>REGIONAL CENTRES (SIZAKALA)</h3>
                <p>Operating Hours 7:30 - 16:00 Mon to Fri
                  <br>One Stop Shops access/payments for council services
                </p>
                <h3>SWITCHBOARD</h3>
                <p>Operating Hours 7:30-17:00, Mon - Fri</p>
              </td>
              <td><a href="tel:0800331011" >080 033 1011</a><br><a href="tel:0313116101" >031 311 6101</a><br><br><a href="tel:0313111111" >031 311 1111</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>


<!--    <div class="card">    
    <button class="btn backBtn" @click="$router.push({ path: '/' })"><i class="icon-left-open"></i></button>
    <div class="cardHeader">
        <span class="mainHeader"><i class="icon-report"></i>Report an issue</span>
        <span class="secondHeader">Send us feedback on any enviromental issues in your area.</span>
    </div>
    <div class="cardBody">
        <div class="input-group">
            <label class="label" for="region_select">
                    Issue Type:
            </label>
            <select class="select" required v-model="formFields.issue" id="region_select">
                <option selected>Storm Flooding</option>
                <option>Potholes</option>
                <option>Fire</option>
            </select>
        </div>
        <div class="input-group">
            <label class="label" for="name" >
                Name:
            </label>
            <input class="select" v-model="formFields.name" id="name" value=""></input>
        </div>
        <div class="input-group">
            <label class="label" for="email">
                Email Address:
            </label>
            <input class="select" v-model="formFields.email" id="email" value=""></input>
        </div>
        <div class="input-group">
            <label class="label" for="mobile_number">
                Contact Number:
            </label>
            <input class="select" v-model="formFields.mobile_number" id="mobile_number" value=""></input>
        </div>
        <div class="input-group">
            <label class="label" for="message">
                Message:
            </label>
            <input type="text" class="select" v-model="formFields.message" id="message" value=""></input>
        </div>
        <div class="upload input-group">
            <input type="file" name="file" id="file" class="imageUpload" @change="fileChange($event.target.name, $event.target.files)" />
            <label for="file"><i class="icon-camera"></i> Upload An Image</label>
        </div>
        <button class="submitButton" @click="sendIssue" v-if="!ui.sending">SEND ISSUE</button>
    </div>
   </div>
   <div class="loadingStatus" v-if="ui.sending"><img src="/static/img/loaderTriangle.svg" alt="Loader">Sending Report...</div>
  </div> -->
</template>

<script>

function getImage (file) {
  return new Promise((resolve, reject) => {
    const fReader = new FileReader()
    const img = document.createElement('img')

    fReader.onload = () => {
      img.src = fReader.result
      resolve(img.src)
    }

    fReader.readAsDataURL(file)
  })
}

export default {
  name: 'report',
  data: function () {
    return {
      'formFields': {
        'name': 'John Doe',
        'email': 'johndoe@mail.com',
        'message': 'Storm water issue on 3rd Street',
        'mobile_number': '0312661338',
        'issue': '',
        'image': ''
      },
      'response': {
        'message': null
      },
      'ui': {
        'sending': false
      }
    }
  },
  methods: {
    sendIssue: function () {
      this.ui.sending = true
      this.$axios.post('environmental-issue/report', this.formFields).then((response) => {
        console.log(response)
        this.ui.sending = false
        window.alertify.success('Saved! Thank you for your report.')
        this.$router.push('/')
      }).catch((error) => {
        this.ui.sending = false
        this.setMessage('We were unable to process your submission')
        window.alertify.error('Unable to process form')
        console.log(error)
      })
    },
    fileChange: function (name, files) {
      getImage(files[0]).then((base64Image) => {
        this.formFields.image = base64Image
      })
    },
    setMessage: function (msg) {
      this.response.message = msg
      setTimeout(() => {
        this.response.message = null
      }, 3000)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
</style>



// WEBPACK FOOTER //
// src/views/Report.vue